// --- IMPORTS ---
import React, { useState, useEffect,useRef } from 'react';
import { Modal, Button, Form, Card, Row, Col, Table,Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import defaultImg from './../../../images/task/img1.jpg';
import { var_api, image_api } from '../../../constant';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
const AdjustmentMaster = () => {

 const tableHeaders = [
  "#", "Adjustment Type", "Mode", "Reason Type",
  "Total Value", "Created By", "Date", "Status", 
];


  const adjustmentTypeOptions = [
    { label: "INCREASE", value: 1 },
    { label: "DECREASE", value: 2 }
  ];

 

  const modeOptions = [
    { label: "Qty Adjustment", value: "qty" },
    { label: "Value Adjustment", value: "value" },
  ];

  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("name");
  const warehouse_id = localStorage.getItem("warehouse_id");
  const [productData, setProductData] = useState([]);
  const [showAdjustDetails, setShowAdjustDetails] = useState(false);
// ADJUSTMENT SUMMARY STATES
const [selectedAdjust, setSelectedAdjust] = useState(null);
const [adjustmentList, setAdjustmentList] = useState([]);
const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  const navigate = useNavigate();


  const [formData, setFormData] = useState({
    adjustment_type: '',
    created_by: userId,
    date: '',
    description: '',
    reason_type: '',
    mode_of_adjustment: '',
    remarks: '',
    total_value: '',
    warehouse_id: warehouse_id,
    image: '',
    status:1
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [reasonData, setReasonData] = useState([]);
  const [reasonSearch, setReasonSearch] = useState("");
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProducts, setSelectedProducts] = useState({});
 const adAdjustRef = useRef(null);


useEffect(() => {
  loadInitialData();
  fetchReasonData(); 
  fetchProductData(); // <-- ADD THIS
}, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchData();
    } catch {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const res = await axios.get(`${var_api}veemart_wh_inventory_adjustment/get`);
      setData(res.data || []);
    } catch {
      toast.error("Failed to fetch data");
    }
  };
const fetchReasonData = async () => {

  try {
    const res = await axios.get(
      `${var_api}sa-veemart-reason-master/get-by-warehouse/${warehouse_id}`
    );
    setReasonData(res.data || []);
  } catch {
    toast.error("Failed to fetch reason list");
  }
};

const fetchProductData = async () => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
    const allProducts = Array.isArray(res.data)
      ? res.data
      : Array.isArray(res.data.data)
      ? res.data.data
      : [];
    setProductData(allProducts);
  } catch (err) {
    toast.error("Failed to fetch product data");
  }
};

// Add product to selected list
const handleAddToSelected = (product) => {
  setSelectedProducts((prev) => {
    const updated = { ...prev };

    if (updated[product.id]) {
      delete updated[product.id];
    } else {
      updated[product.id] = {
        id: product.id,
        product_name: product.product_name,
        qty_count: 1,
      };
    }
    return updated;
  });
};
const handleQtyChange = (id, value) => {
  setSelectedProducts((prev) => ({
    ...prev,
    [id]: {
      ...prev[id],
      qty_count: value,
    },
  }));
};
const handleConfirmBulkAdd = () => {
  const newRows = Object.values(selectedProducts).map((item) => ({
    product_id: item.id,
    product_name: item.product_name,
    qty: item.qty_count,
    qty_in_hand: 0,
    qty_adjusted: 0,
  }));

  setItems((prev) => [...prev, ...newRows]);

  setShowBulkModal(false);
  setSelectedProducts({});
};


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));

    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleAddClick = () => {
  setFormData({
    adjustment_type: '',
    created_by: userId,
    date: '',
    description: '',
    reason_type: '',
    mode_of_adjustment: '',
    remarks: '',
    total_value: '',
    warehouse_id: warehouse_id,
    image: '',
        status:1

  });
  setFile(null);
  setIsEditMode(false);
  setErrors({});
  setShowForm(true);   // SHOW FORM CARD
};


 const handleEditClick = (item) => {

  setShowAdjustDetails(false);

  setShowForm(true);

  setIsEditMode(true);

  setFormData({ ...item });

  setFile(null);
  setErrors({});
};



const handleSubmit = async (e) => {
  e.preventDefault();

  const newErrors = {};
  if (!formData.adjustment_type) newErrors.adjustment_type = "Required";
  if (!formData.reason_type) newErrors.reason_type = "Required";
  if (!formData.mode_of_adjustment) newErrors.mode_of_adjustment = "Required";

  setErrors(newErrors);
  if (Object.keys(newErrors).length > 0) {
    toast.warning("Please fill mandatory fields");
    return;
  }

  try {
    setLoading(true);

    // convert item table to backend format
    const detailsPayload = items.map(row => ({
      sa_variant_master_id: row.product_id,
      warehouse_product_master_id: row.product_id,
      old_qty: Number(row.qty),
      new_qty: Number(row.qty_in_hand),
      difference_qty: Number(row.qty_adjusted),
      unit_cost: row.unit_cost || 0,
      total_cost: row.total_cost || 0,
      remarks: row.remarks || ""
    }));

    const form = new FormData();
    Object.keys(formData).forEach(key => form.append(key, formData[key]));
    form.append("details", JSON.stringify(detailsPayload));
    if (file) form.append("image", file);

    const headers = { headers: { 'Content-Type': 'multipart/form-data' } };

    let res;
    if (isEditMode && formData.id) {
      res = await axios.put(`${var_api}veemart_wh_inventory_adjustment/update/${formData.id}`, form, headers);
    } else {
      res = await axios.post(`${var_api}veemart_wh_inventory_adjustment/post`, form, headers);
    }

    toast.success(res?.data?.message || "Saved successfully");
    setShowForm(false);
    fetchData();

  } catch (err) {
    toast.error(err?.response?.data?.message || "Error saving");
  } finally {
    setLoading(false);
  }
};



const [items, setItems] = useState([
  { product_id: "", product_name: "", qty: 0, qty_in_hand: 0, qty_adjusted: 0 }
]);


const handleItemChange = (index, field, value) => {
  const updated = [...items];
  updated[index][field] = value;

  // Auto update qty_adjusted = qty_in_hand - qty
  if (field === "qty" || field === "qty_in_hand") {
    updated[index].qty_adjusted =
      Number(updated[index].qty_in_hand) - Number(updated[index].qty);
  }

  // When product changes → auto-fill product_name
  if (field === "product_id") {
    const selected = productData.find((p) => p.id == value);
    updated[index].product_name = selected?.product_name || "";
  }

  setItems(updated);
};

const handleAddRow = () => {
  setItems([
    ...items,
    { product_id: "", product_name: "", qty: 0, qty_in_hand: 0, qty_adjusted: 0 }
  ]);
};

const handleRemoveRow = (index) => {
  const updated = items.filter((_, i) => i !== index);
  setItems(updated);
};

const handleViewAdjust = async (adjust) => {
  setSelectedAdjust(adjust);
  localStorage.setItem("adjustment_id", adjust.id);

  try {
    const res = await axios.get(
      `${var_api}veemart_wh_inventory_adjustment_details/getByAdjustmentId/${adjust.id}`
    );

    const apiData = Array.isArray(res.data.data) ? res.data.data : [];

    const formatted = apiData.map((item) => ({
      product_id: item.warehouse_product_master_id,
      product_name: item.product_name,   // 👈 DIRECT USE
      old_qty: item.old_qty ?? 0,
      new_qty: item.new_qty ?? 0,
      difference: Number(item.difference_qty ?? 0),
    }));

    setAdjustmentList(formatted);
    setShowAdjustDetails(true);

  } catch (err) {
    console.error(err);
    toast.error("Failed to fetch adjustment details");
  }
};

const handleDownloadPDF = async () => {
  if (!adAdjustRef.current) {
    toast.error("Right section not found!");
    return;
  }

  const input = adAdjustRef.current;
  const canvas = await html2canvas(input, { scale: 2 });
  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  pdf.save("AdjustmentDetails.pdf");
};

const handlePrint = () => {
  if (!adAdjustRef.current) {
    toast.error("Right section not found!");
    return;
  }

  const printContent = adAdjustRef.current.innerHTML;
  const win = window.open("", "", "height=700,width=900");
  win.document.write("<html><head><title>Print</title></head><body>");
  win.document.write(printContent);
  win.document.write("</body></html>");
  win.document.close();
  win.print();
};

const handleMarkAsAdjusted = async (id) => {
  try {
    const payload = {
      id: id,
      status: 2   
    };

    const res = await axios.put(
      `${var_api}veemart_wh_inventory_adjustment/update-adjustment-status`,
      payload
    );

    if (res.data.status === 1) {
      toast.success("Marked as Adjusted!");
      setShowAdjustDetails(false);   // close the detail view
      fetchData();         // refresh table
    } else {
      toast.error(res.data.message || "Failed to update");
    }

  } catch (error) {
    console.error(error);
    toast.error("Error updating status");
  }
};

const formatDate = (dateString) => {
  if (!dateString) return "-";
  const d = new Date(dateString);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

  const filteredData = data.filter(item =>
    Object.values(item).some(val =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

 
   return (
  <>
    <Card>
      <Card.Body>
{/* ===== MAIN CONDITIONAL START ===== */}
{showAdjustDetails ? (
  /* ============================================================
     SHOW ADJUSTMENT DETAILS ONLY
  ============================================================ */
  showAdjustDetails && selectedAdjust && (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom right, #f8f9fa, #e9ecef)",
        padding: "20px",
      }}
    >
      <Card
        className="shadow-lg border-0"
        style={{
          width: "100%",
          maxWidth: "1400px",
          borderRadius: "16px",
          overflow: "hidden",
        }}
      >
        <Card.Body className="p-0">
          <Row className="g-0">

            {/* LEFT SIDE PANEL ------------------------------------------------ */}
            <Col md={3} style={{ backgroundColor: "#f8f9fa", borderRight: "1px solid #dee2e6" }}>
              <div className="p-4">
                <h6 className="fw-bold mb-4">All Adjustments</h6>

                <Card className="mb-2" style={{ border: "2px solid #007bff" }}>
                  <Card.Body>
                    <h6 className="fw-bold mb-1">
                      {reasonData.find(r => r.id == selectedAdjust.reason_type)?.reason_name || "-"}
                    </h6>

                    <small className="text-muted">{selectedAdjust.date}</small>

                    <div className="text-end mt-2">
                      <h6 className="mb-0">₹{selectedAdjust.total_value}</h6>
                    </div>

                    <div className="text-end mt-2">
                      <h6 className="mb-0">{userName}</h6>
                    </div>
                  </Card.Body>
                </Card>

              </div>
            </Col>

            {/* RIGHT SIDE PANEL ----------------------------------------------- */}
            <Col md={9}>
              <div className="p-4">

                {/* TOP HEADER ------------------------------------------------ */}
                <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">

                  {/* Left: Back + Title */}
                  <div className="d-flex align-items-center gap-3">
                    <Button 
                      variant="outline-secondary" 
                      size="sm" 
                      onClick={() => setShowAdjustDetails(false)}
                    >
                      <i className="fas fa-arrow-left me-2"></i>Back
                    </Button>

                    <h4 className="fw-bold mb-0">Adjustment #{selectedAdjust.adjust_no}</h4>
                  </div>

                  {/* Right: Buttons */}
                  <div className="d-flex align-items-center gap-2">

                    {selectedAdjust.status == 1 && (
                      <Button 
                        variant="success" 
                        size="sm" 
                        onClick={() => handleMarkAsAdjusted(selectedAdjust.id)}
                      >
                        <i className="fas fa-check me-2"></i>Mark as Adjusted
                      </Button>
                    )}

                    <Dropdown>
                      <Dropdown.Toggle variant="outline-secondary" size="sm">
                        <i className="fas fa-file-pdf me-2"></i>PDF / Print
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={handleDownloadPDF}>Download PDF</Dropdown.Item>
                        <Dropdown.Item onClick={handlePrint}>Print</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <Button 
                      variant="primary" 
                      size="sm" 
                      onClick={() => handleEditClick(selectedAdjust)}
                    >
                      <i className="fas fa-edit me-2"></i>Edit
                    </Button>

                  </div>
                </div>

                {/* STATUS RIBBON + DETAILS CARD ------------------------------ */}
                <div ref={adAdjustRef} className="position-relative d-flex justify-content-center mb-4">
                  <Card
                    className="shadow border-0 position-relative"
                    style={{
                      width: "100%",
                      maxWidth: "800px",
                      borderRadius: "12px",
                      backgroundColor: "#fff",
                    }}
                  >

                    {/* Ribbon */}
                    <div
                      style={{
                        position: "absolute",
                        top: "20px",
                        left: "-30px",
                        backgroundColor: selectedAdjust.status === 1 ? "#6c757d" : "#28a745",
                        color: "#fff",
                        transform: "rotate(-45deg)",
                        width: "150px",
                        textAlign: "center",
                        padding: "5px 0",
                        fontWeight: "600",
                        fontSize: "12px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                      }}
                    >
                      {selectedAdjust.status === 1 ? "DRAFT" : "ADJUSTED"}
                    </div>

                    {/* Main Details */}
                    <Card.Body className="p-5">

                      <div className="text-center mb-5">
                        <h2 className="fw-bold" style={{ fontSize: "32px" }}>STOCK ADJUSTMENT</h2>
                      </div>

                      <Row className="mb-5">
                        <Col md={6}>
                          <p><strong>Created By:</strong> {userName}</p>
                          <p><strong>Date:</strong> {selectedAdjust.date}</p>
                          <h6 className="fw-bold mb-1"><strong>Adjustment Type:</strong>
                            {adjustmentTypeOptions.find(a => a.value == selectedAdjust.adjustment_type)?.label || "-"}
                          </h6>
                        </Col>

                        <Col md={6} className="text-end">
                          <p className="text-muted mb-1"><strong>Reason Type:</strong>
                            {reasonData.find(r => r.id == selectedAdjust.reason_type)?.reason_name || "-"}
                          </p>
                          <p><strong>Mode:</strong> {selectedAdjust.mode_of_adjustment}</p>
                        </Col>
                      </Row>

                      {/* ITEM TABLE ------------------------------------------ */}
                      <div className="table-responsive mb-5">
                        <table className="table table-bordered">
                          <thead style={{ backgroundColor: "#343a40", color: "#fff" }}>
                            <tr>
                              <th>#</th>
                              <th>Product</th>
                              <th className="text-end"> Qty</th>
                              <th className="text-end"> Qty in hand</th>
                              <th className="text-end"> Qty Adjusted</th>
                            </tr>
                          </thead>

                          <tbody>
                            {adjustmentList.map((item, idx) => (
                              <tr key={idx}>
                                <td>{idx + 1}</td>
                                <td>{item.product_name}</td>
                                <td className="text-end">{item.old_qty}</td>
                                <td className="text-end">{item.new_qty}</td>
                                <td className="text-end">{item.difference_qty}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* TOTAL VALUE ---------------------------------------- */}
                      <Row className="justify-content-end">
                        <Col md={6}>
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="text-end border-0"><strong>Total Adjustment Value</strong></td>
                                <td className="text-end border-0"><strong>₹{selectedAdjust.total_value}</strong></td>
                              </tr>
                            </tbody>
                          </table>
                        </Col>
                      </Row>

                    </Card.Body>
                  </Card>
                </div>

              </div>
            </Col>

          </Row>
        </Card.Body>
      </Card>
    </div>
  )

) : showForm ? (
  /* ============================================================
     SHOW ADD / EDIT FORM ONLY
  ============================================================ */
  <>
    <h4 className="mb-3">{isEditMode ? "Edit Adjustment" : "Add Adjustment"}</h4>

<Form onSubmit={handleSubmit} className="p-4">


  <Row className="gy-4">
    {/* MODE OF ADJUSTMENT */}
    <Col md={12}>
      <Form.Group>
        <Form.Label className="fw-semibold">Mode of Adjustment <span className="text-danger">*</span></Form.Label>
        <div className="d-flex gap-4 mt-2">
          {modeOptions.map(opt => (
            <Form.Check
              key={opt.value}
              inline
              label={opt.label}
              name="mode_of_adjustment"
              type="radio"
              value={opt.value}
              checked={formData.mode_of_adjustment == opt.value}
              onChange={handleInputChange}
              className="fw-medium"
            />
          ))}
        </div>
      </Form.Group>
    </Col>

    {/* REASON TYPE + ADJUSTMENT TYPE */}
    <Col md={6}>
      <Form.Group>
        <Form.Label className="fw-semibold">Reason Type <span className="text-danger">*</span></Form.Label>
        <Form.Select
          name="reason_type"
          value={formData.reason_type}
          onChange={handleInputChange}
          className="shadow-sm rounded"
        >
          <option value="">Select Reason</option>
          {reasonData.map(r => (
            <option key={r.id} value={r.id}>{r.reason_name}</option>
          ))}
        </Form.Select>
        {errors.reason_type && <small className="text-danger">{errors.reason_type}</small>}
      </Form.Group>
    </Col>

    <Col md={6}>
      <Form.Group>
        <Form.Label className="fw-semibold">Adjustment Type <span className="text-danger">*</span></Form.Label>
        <Form.Select
          name="adjustment_type"
          value={formData.adjustment_type}
          onChange={handleInputChange}
          className="shadow-sm rounded"
        >
          <option value="">Select</option>
          {adjustmentTypeOptions.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </Form.Select>
        {errors.adjustment_type && <small className="text-danger">{errors.adjustment_type}</small>}
      </Form.Group>
    </Col>

    {/* DATE + TOTAL VALUE */}
    <Col md={6}>
      <Form.Group>
        <Form.Label className="fw-semibold">Date</Form.Label>
        <Form.Control
          type="date"
          name="date"
          value={formData.date}
          onChange={handleInputChange}
          className="shadow-sm rounded"
        />
      </Form.Group>
    </Col>

    <Col md={6}>
      <Form.Group>
        <Form.Label className="fw-semibold">Total Value</Form.Label>
        <Form.Control
          type="number"
          name="total_value"
          value={formData.total_value}
          onChange={handleInputChange}
          className="shadow-sm rounded"
          placeholder="Enter value"
        />
      </Form.Group>
    </Col>
  </Row>

  {/* ITEM TABLE */}
  <h5 className="fw-bold text-secondary border-bottom pb-2 mt-4">Item Table</h5>

  <Table bordered hover responsive className="shadow-sm rounded">
    <thead className="bg-light text-center">
      <tr>
        <th>Product</th>
        <th>Qty</th>
        <th>Qty In Hand</th>
        <th>Adjusted</th>
        <th>Action</th>
      </tr>
    </thead>

    <tbody>
      {items.length === 0 ? (
        <tr>
          <td colSpan={5} className="text-center text-muted py-3">
            No items added yet
          </td>
        </tr>
      ) : (
        items.map((item, idx) => (
          <tr key={idx}>
           <td> <Form.Control type="text" value={item.product_name} onChange={(e) => handleItemChange(idx, "product_name", e.target.value)} placeholder="Enter product" className="shadow-sm rounded" /> </td>

            <td>
              <Form.Control
                type="number"
                value={item.qty}
                onChange={(e) => handleItemChange(idx, "qty", e.target.value)}
              />
            </td>

            <td>
              <Form.Control
                type="number"
                value={item.qty_in_hand}
                onChange={(e) => handleItemChange(idx, "qty_in_hand", e.target.value)}
              />
            </td>

            <td className="fw-bold text-primary text-center">
              {item.qty_adjusted}
            </td>

            <td className="text-center">
              <Button
                variant="danger"
                size="sm"
                className="rounded-pill px-3"
                onClick={() => handleRemoveRow(idx)}
              >
                Delete
              </Button>
            </td>
          </tr>
        ))
      )}
    </tbody>
  </Table>

  {/* ADD ROW BUTTONS */}
  <div className="d-flex gap-4 mb-4">
    <Button variant="link" className="p-0 fw-semibold" onClick={handleAddRow}>
      + Add New Row
    </Button>

    <Button variant="link" className="p-0 fw-semibold" onClick={() => setShowBulkModal(true)}>
      + Add Items in Bulk
    </Button>
  </div>

  {/* DESCRIPTION + REMARKS */}
  <Row className="gy-4">
    <Col md={6}>
      <Form.Group>
        <Form.Label className="fw-semibold">Description</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          name="description"
          placeholder='Enter Description'
          value={formData.description}
          onChange={handleInputChange}
          className="shadow-sm rounded"
        />
      </Form.Group>
    </Col>

    <Col md={6}>
      <Form.Group>
        <Form.Label className="fw-semibold">Remarks</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          name="remarks"
                    placeholder='Enter Remarks'

          value={formData.remarks}
          onChange={handleInputChange}
          className="shadow-sm rounded"
        />
      </Form.Group>
    </Col>
  </Row>

  {/* IMAGE */}
  <div className="mt-3" style={{ maxWidth: "600px" }}>
    <Form.Group>
      <Form.Label className="fw-semibold">Image <span className="text-danger">*</span></Form.Label>

      {isEditMode && formData.image && !file && (
        <div className="mb-2">
          <img
            src={`${image_api}${formData.image.replace(/^test\//, '')}`}
            alt="Preview"
            width="120"
            className="rounded border shadow-sm"
          />
        </div>
      )}

      <Form.Control
        type="file"
        accept="image/*"
        onChange={(e) => setFile(e.target.files[0])}
        className="shadow-sm rounded"
      />
    </Form.Group>
  </div>

  {/* ACTION BUTTONS */}
 <div className="d-flex justify-content-end gap-3 mt-4">
  <Button
    type="submit"
    variant={isEditMode ? "warning" : "secondary"}
    style={{
      borderRadius: "6px",      // mild radius
      minWidth: "140px"
    }}
    disabled={loading}
  >
    {loading ? "Saving..." : isEditMode ? "Update" : "Save as Draft"}
  </Button>

  <Button
    variant="danger"
    style={{
      borderRadius: "6px",      // same mild radius
      minWidth: "120px"
    }}
    onClick={() => setShowCancelConfirm(true)}
    disabled={loading}
  >
    Cancel
  </Button>
</div>

</Form>


  </>

) : (
  /* ============================================================
     SHOW TABLE ONLY
  ============================================================ */
  <>
    <div className="d-flex justify-content-end mb-3 gap-2">
      <input
        type="text"
        className="form-control w-auto"
        placeholder="Search..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <Button variant="secondary" onClick={handleAddClick}>Add</Button>
    </div>

    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            {tableHeaders.map((h, i) => (
              <th key={i}>{h}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {paginatedData.length === 0 ? (
            <tr><td colSpan="10" className="text-center">No Data Found</td></tr>
          ) : (
            paginatedData.map((item, idx) => (
              <tr key={item.id}>
                <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>

<td>
  <span
    className={`badge ${
      item.adjustment_type == 1 ? "bg-success" :
      item.adjustment_type == 2 ? "bg-danger" :
      "bg-secondary"
    }`}
  >
    {adjustmentTypeOptions.find(x => x.value == item.adjustment_type)?.label || "-"}
  </span>
</td>
                <td>{item.mode_of_adjustment}</td>
<td>
  <span
    className={`badge ${
      item.reason_type == 1 ? "bg-primary" :
      item.reason_type == 2 ? "bg-warning text-white" :
      item.reason_type == 3 ? "bg-orange text-white" :
      item.reason_type == 4 ? "bg-info text-white" :
      item.reason_type == 5 ? "bg-danger" :
      item.reason_type == 6 ? "bg-secondary" :
      "bg-light"
    }`}
  >
    {reasonData.find(x => x.id == item.reason_type)?.reason_name || "-"}
  </span>
</td>
                <td>{item.total_value}</td>
                <td>{userName || "-"}</td>
                             <td>{formatDate(item.date)}</td>

               <td>
  {item.status == 1 ? (
    <span
      className="badge"
      style={{
        backgroundColor: "#ffe8b3",   // light background to match your #c47f00 text
        color: "#e1960bff",
        fontWeight: 500,
        cursor: "pointer",
      }}
      onClick={() => handleViewAdjust(item)}
    >
      Draft
    </span>
  ) : item.status == 2 ? (
    <span
      className="badge"
      style={{
        backgroundColor: "#d4f8d4",   // light green background
        color: "green",
        fontWeight: 500,
        cursor: "pointer",
      }}
      onClick={() => handleViewAdjust(item)}
    >
      Adjusted
    </span>
  ) : (
    "-"
  )}
</td>


              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </>
)}
{/* ===== MAIN CONDITIONAL END ===== */}




      </Card.Body>
    </Card>

<Modal
  show={showCancelConfirm}
  onHide={() => setShowCancelConfirm(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title className="text-danger fw-bold">
      <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
      Leave this page?
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p>If you leave, your unsaved changes will be discarded.</p>
  </Modal.Body>

  <Modal.Footer className="d-flex justify-content-end">
    <Button
      variant="primary"
      className="px-4"
      style={{ borderRadius: "6px", backgroundColor: "#007bff", border: "none" }}
      onClick={() => setShowCancelConfirm(false)}
    >
      Stay Here
    </Button>

  <Button
  variant="light"
  className="px-4 text-dark border"
  style={{ borderRadius: "6px", backgroundColor: "#e0e0e0" }}
  onClick={() => {
    setShowCancelConfirm(false);
    setShowModal(false);         // close modal
    setShowForm(false);          // hide form
    setShowAdjustDetails(false); // show table
  }}
>
  Leave & Discard Changes
</Button>

  </Modal.Footer>
</Modal>




<Modal
  show={showBulkModal}
  onHide={() => setShowBulkModal(false)}
  size="xl"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Add Items in Bulk</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Row>
      {/* LEFT SIDE - Product List */}
      <Col md={6} style={{ borderRight: "1px solid #ddd" }}>
        <Form.Control
          type="text"
          placeholder="Search products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="mb-3"
        />

        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          {productData
            .filter((p) =>
              p.product_name.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .map((p) => (
              <div
                key={p.id}
                className="d-flex justify-content-between align-items-center mb-2"
              >
                <span>{p.product_name}</span>

                <Button
                  variant={
                    selectedProducts[p.id] ? "secondary" : "outline-danger"
                  }
                  size="sm"
                  onClick={() => handleAddToSelected(p)}
                >
                  {selectedProducts[p.id] ? "✓" : "+"}
                </Button>
              </div>
            ))}
        </div>
      </Col>

      {/* RIGHT SIDE - Selected Items */}
      <Col md={6}>
        <h6>Selected Items (Qty)</h6>

        {Object.keys(selectedProducts).length === 0 ? (
          <p className="text-muted">No items selected</p>
        ) : (
          Object.values(selectedProducts).map((item) => (
            <div
              key={item.id}
              className="d-flex justify-content-between align-items-center mb-2"
            >
              <span>{item.product_name}</span>

              <Form.Control
                type="number"
                value={item.qty_count}
                onChange={(e) =>
                  handleQtyChange(item.id, Number(e.target.value))
                }
                style={{ width: "80px" }}
              />
            </div>
          ))
        )}
      </Col>
    </Row>
  </Modal.Body>

  <Modal.Footer className="d-flex justify-content-end gap-2">
    <Button
      variant="primary"
      onClick={handleConfirmBulkAdd}
      style={{
        borderRadius: "6px",
        minWidth: "120px",
        backgroundColor: "#007bff",
        border: "none",
      }}
    >
      Add Products
    </Button>

    <Button
      variant="secondary"
      onClick={() => setShowBulkModal(false)}
      style={{
        borderRadius: "6px",
        minWidth: "120px",
        backgroundColor: "#e0e0e0",
        color: "#000",
        border: "none",
      }}
    >
      Cancel
    </Button>
  </Modal.Footer>
</Modal>

    <ToastContainer />
  </>
);

};

export default AdjustmentMaster;
